import { render, staticRenderFns } from "./IndexDefault.vue?vue&type=template&id=56c6d14e&scoped=true"
import script from "./IndexDefault.vue?vue&type=script&lang=js"
export * from "./IndexDefault.vue?vue&type=script&lang=js"
import style0 from "./IndexDefault.vue?vue&type=style&index=0&id=56c6d14e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6d14e",
  null
  
)

export default component.exports